/*
*###############################################################################
*Module Name                   : AreaMasterContent.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Wednesday, August 25th 2021, 6:21:19 pm       #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from "react"
import { CardText, Col, Row, Button, Alert, Label } from "reactstrap"


import DPTextBox from "../../../framework/components/DPTextBox"
import DPSwitch from "framework/components/DPSwitch"
import DPTextBoxButton from 'framework/components/DPTextBoxButton'
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import MasterUpload from "../../../assets/File/MasterUpload.xlsx";
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import { loadPopupSearchPay } from "../../../framework/validators/SearchColumn"
//Import DPComponents
const AreaMasterContent = ({
  GetSelectRow,
  CodeValue,
  CodeonChange,
  DescValue,
  DesconChange,
  modelTrigger,
  modelOpen,
  ActiveSw,
  SwonChange,
  show,
  disabled,
  disabledCode,
  AlertColor,
  AlertMsg,
  CodeOnBlur,
  ErrorMsg,
  menuName,
  onButtonClick,
  btnDisable,
  SearchDisable,
  showFileUpload,
  valueUpload,
  menuCode,
  autoCode
}) => {

  const [HeadColumns, setHeadColumns] = useState([])
  const [groupFilter, SetGroupFilter] = useState("a")
  const ApiURL = window.Links.ApiURL


  useEffect(async () => {
    setHeadColumns(await loadPopupSearchPay(menuCode, 'AREA'))
  }, [menuCode]);


  async function tog_backdrop() {
    modelTrigger();
  }


  const defaultSorted = [{
    dataField: 'id',
    order: 'asc'
  }];


  // end modal props

  return (
    <form>
      <React.Fragment>
        <div>
          <Col sm="12">
            <CardText className="mb-0">
              <Row>
                {show ? (
                  <Alert color={AlertColor} role="alert">
                    {AlertMsg}
                    <br />
                    <small>{ErrorMsg}</small>
                  </Alert>
                ) : null}
                <Col sm={12} md={6} className="mb-4-sm">
                  <DPTextBoxButton
                    rowClass="mb-3-sm"
                    labelText="Code *"
                    textType="text"
                    value={CodeValue}
                    onBlur={CodeOnBlur}
                    onChange={CodeonChange}
                    disabled={disabled == true ? disabled : disabledCode}
                    onButtonClick={onButtonClick}
                    btnDisable={disabled == true ? disabled : btnDisable}
                    placeholder={autoCode}
                  />

                  <DPTextBox
                    rowClass="mb-3-sm"
                    labelText="Description *"
                    textType="text"
                    maxLength="40"
                    value={DescValue}
                    onChange={DesconChange}
                    disabled={disabled}
                  />
                  <Row>
                    <Col sm={3}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Active
                      </Label>
                    </Col>
                    <Col >
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        onChange={SwonChange}
                        checked={ActiveSw}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>

                </Col>

                <Col sm={12} md={4} className="mb-4-sm">
                  <Button
                    onClick={() => {
                      tog_backdrop()
                    }}
                    color="success"
                    className="btn-sm"
                    disabled={SearchDisable}
                  >
                    <i
                      className="mdi mdi-search-web"
                      style={{ fontSize: "12px" }}
                    ></i>
                  </Button>
                </Col>
                <Col sm={12} md={2} className="mb-4-sm">
                  <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px", justifyContent: "end" }}>
                    <li className="import-export-button" style={{ display: "block" }}>
                      <input
                        id="file"
                        type="file"
                        onChange={showFileUpload}
                        value={valueUpload}
                        disabled={disabledCode}
                        accept=".xlsx, .xls, .csv"
                        style={{ display: "none" }}
                      />
                      <label htmlFor="file" title="Master Excel Upload" style={{ cursor: "pointer", opacity: disabledCode == true ? "0.5" : "1" }}>
                        <span >
                          <img class="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px" }}></img>
                        </span>
                      </label></li>
                    <li className="import-export-button" style={{ display: "block" }}>
                      <a href={MasterUpload} download="Master File Upload" data-tip title="Master excel format download"
                        style={{ pointerEvents: disabledCode ? 'none' : '', }} >
                        <img class="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: disabledCode == true ? "0.5" : "1" }}></img>
                      </a></li>
                  </ul>
                </Col>

                <DPSearchBoxDynamic
                  searchData={[]}
                  columns={HeadColumns}
                  defaultSorted={defaultSorted}
                  mainTitle={menuName + " Search"}
                  SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                  isOpen={modelOpen}
                  toggle={modelTrigger}
                  getSelect={GetSelectRow}
                  APIURL={ApiURL}
                  URLPath={"AREA"}
                  MenuCode={menuCode}
                  KeyVal={"ARE"}
                  searchBy={"AM_CODE"}
                  FilterStr={groupFilter}
                />


              </Row>
            </CardText>
          </Col>
        </div>
      </React.Fragment>
    </form>
  )
}
export default AreaMasterContent
